import { hasRecoveryData, saveRecoveryData } from "../data";
import { AdBlockerType, SoftwallRecoveredType } from "../types";
import { appendKVPToAdRequest, sendEvent, isSessionRecovered } from "../utils";
import { log, shouldLogByProbability } from "../utils/logs";

export function onRecover(
  recovered: SoftwallRecoveredType,
  attributionExpiry: number,
  loadTS: number,
) {
  if (isSessionRecovered(recovered, attributionExpiry)) {
    appendKVPToAdRequest();
    const kvpTiming = performance.now() - loadTS;

    // keep log for now, but only for 1% of page loads
    if (shouldLogByProbability()) {
      log(
        "rlink.appendKVP",
        {
          aaResults: window.__bt_intrnl.aaDetectionResults,
          attributionExpiry,
          consentData: window.__bt_intrnl.consentData,
        },
        { severity: 1 },
      );
    }

    sendEvent({
      event: "kvp",
      meta: {
        latency: Math.round(kvpTiming), // round to milliseconds
      },
      recoveryType: recovered,
      detectedExtension: "unknown", // extension is not defined at this step yet in order to reduce latency
    }).catch(() => null);
  }
}

export async function onRecoverEvent(
  recovered: SoftwallRecoveredType,
  attributionExpiry: number,
  detectedExtension: AdBlockerType,
): Promise<void> {
  if (!(await hasRecoveryData())) {
    sendEvent({
      event: "recovered",
      recoveryType: recovered,
      detectedExtension,
    }).catch(() => null);

    return saveRecoveryData(recovered, attributionExpiry);
  }
}
